import React, { useContext, useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext'; // Importa il contesto
import Testata from "./partials/Testata";
// import NavBar from "./partials/NavBar";
import Footer from "./partials/Footer";
import Cuoricini from "./partials/Cuoricini";
import AzioniRapide from "./partials/AzioniRapide";
import moment from 'moment'; // Importa moment.js
import $ from 'jquery';
import 'datatables.net';
function Dashboard() {
  const { userData } = useContext(UserContext); // Ottieni userData dal contesto  
  const [annunci, setAnnunci] = useState([]); // Stato per gli annunci
  const [errorDoc, setDocError] = useState(null);
  const [likes, setLikes] = useState(0);
  //   const navigate = useNavigate();
  
  useEffect(() => {   
    const fetchAnnunci = async () => {
      const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/annunciUser`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
            });

            if (response.ok) {
                const annunci = await response.json();
                setAnnunci(annunci); // Aggiorna lo stato con i Clienti ricevuti
            } else {
                throw new Error('Errore nel recupero degli annunci');
            }
        } catch (err) {
            setDocError(err.message);
        }
    };

    fetchAnnunci(); 
  }, []);// Chiama la funzione per recuperare i Clienti    

  // Ref per l'elemento della tabella
  const tableRef = useRef(null);

  useEffect(() => {
  // Funzione per inizializzare o aggiornare la DataTable
  let table;

  const initializeOrUpdateTable = () => {
      if (!$.fn.DataTable.isDataTable(tableRef.current)) {
        // Inizializza la DataTable solo se non è già stata inizializzata
        table = $(tableRef.current).DataTable({ // Assegna il valore a table
            ordering: false,
            searching: true,
            paging: true,
            pagingType: "full",
            info: true,
            dom: "frtip",
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            language: {
            url: "/js/it-IT.json",
            },
            pageLength: 10,
        });
      }
    };

    // Verifica se tableRef.current è definito prima di inizializzare o aggiornare
    if (tableRef.current) {
        setTimeout(initializeOrUpdateTable, 500); // Timeout per garantire che il DOM sia pronto
    }

  // Distruggi la DataTable quando il componente viene smontato
  return () => {
    if (table && table.destroy) { // Controlla se table è definito e ha il metodo destroy
        table.destroy();
        }
    };
    }, [annunci]);

    
  // Esegui l'effetto solo al montaggio del componente
  return (
    <>
        <section className="main_content dashboard_part">
            <div className="container-fluid g-0">
                <Testata userData={userData} />
            </div>
            <div className="main_content_iner ">
                <div className="container-fluid plr_30 body_white_bg pt_30">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">                    
                            <AzioniRapide />                            
                        </div>                        
                    
                    
                        <div className="col-lg-12 col-xl-12">
                            <div className="white_box mb_30 min_430">
                                {/* <div className="box_header  box_header_block ">
                                    <div className="main-title">
                                        <h3 className="mb-0">Annunci pubblicati</h3>
                                    </div>
                                </div> */}
                                {errorDoc ? (
                                    <tr><td colSpan="4"> <h5>Errore: {errorDoc}</h5> </td></tr>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-striped" id="datatable" style={{width: '100%'}} ref={tableRef}>
                                            <thead>
                                                <tr>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Codice Fiscale</i></th>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Nominativo</i></th>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Ubicazione</i></th>
                                                    <th style={{textAlign: 'center', fontWeight: '700', color: '#7e69d1'}}><i>Pubblicato in data</i></th>
                                                    <th> </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {annunci.map(annuncio => (
                                                    <tr key={annuncio._id}>
                                                        <td>
                                                            {annuncio.codfisc}
                                                        </td>  
                                                        <td>
                                                            <p style={{color: '#b19DC9', fontWeight: '700', textDecoration: 'none' }}>
                                                                {annuncio.cuori > 0 && <Cuoricini likes={annuncio.cuori} />}{" "}
                                                                <a href={`/annuncio/${annuncio._id}`}>{annuncio.nome} {annuncio.cognome} <i className="ti-arrow-top-right"></i></a>
                                                            </p>
                                                        </td>                                                        
                                                        <td style={{paddingTop: '20px'}}><p style={{textTransform: 'capitalize', fontWeight: '300'}}>{annuncio.cap} - {annuncio.comune} ({annuncio.prov})</p></td>
                                                        <td style={{paddingTop: '20px', textAlign: 'center'}}><p style={{fontWeight: '400'}}>{moment(annuncio.data_crea).format('DD/MM/YYYY')}</p></td>
                                                        <td style={{width: '60px', textAlign: 'right'}}>
                                                            <a href={`/annuncio/${annuncio._id}`} className="btn btn-sm btn-primary" title="Visualizza/Modifica">
                                                                <i className='ti-search'></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Codice Fiscale</i></th>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Nominativo</i></th>
                                                    <th style={{fontWeight: '700', color: '#7e69d1'}}><i>Ubicazione</i></th>
                                                    <th style={{textAlign: 'center', fontWeight: '700', color: '#7e69d1'}}><i>Pubblicato in data</i></th>
                                                </tr>
                                            </tfoot>                                          
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>                        
                    </div>
                </div> 
            </div>           
            <Footer />
      </section>
    </>
  );
}

export default Dashboard;